import type { TaxListDetailReportState } from './TaxListDetailReportState';
import { initialTaxListDetailReportState, emptyTaxListDetailReport } from './TaxListDetailReportState';
import type { TaxListDetailReportAction } from 'actions/insights/sales/taxListDetailReport/TaxListDetailReportActionsTypes';
import {
    TAX_LIST_DETAIL_REPORT_GET_ERROR,
    TAX_LIST_DETAIL_REPORT_GET_START,
    TAX_LIST_DETAIL_REPORT_GET_SUCCESS
} from 'actions/insights/sales/taxListDetailReport/TaxListDetailReportActionsTypes';

export const TaxListDetailReportReducer = (
    state: TaxListDetailReportState = initialTaxListDetailReportState,
    action: TaxListDetailReportAction
): TaxListDetailReportState => {
    switch (action.type) {
        case TAX_LIST_DETAIL_REPORT_GET_START:
            return { ...state, loading: true };

        case TAX_LIST_DETAIL_REPORT_GET_SUCCESS:
            return { loading: false, report: action.payload.report };

        case TAX_LIST_DETAIL_REPORT_GET_ERROR:
            return { loading: false, report: emptyTaxListDetailReport() };

        default:
            return state;
    }
};
